exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headContainer{position:fixed;top:0;left:0;width:100%;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;padding:1.6vh 17.5%;-ms-flex-pack:distribute;justify-content:space-around;z-index:99}.headContainer,.headContainer .title{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.headContainer .title{font-size:1vw;color:#3d3d3d;font-weight:700}.headContainer .logo{width:1.5vw;height:1.5vw;margin-right:.5vw}.headContainer .selCont{font-size:.83vw;color:#333;font-weight:500;cursor:pointer}.headContainer .active,.headContainer .selCont:hover{color:#093cb1;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c68efbb4","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/headCont/index.vue
// module id = 5ha/
// module chunks = 24